// src/apollo/client.ts
import { ApolloClient, InMemoryCache, HttpLink, split, ApolloLink } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
// Read endpoints from environment variables
const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT || 'http://localhost:4000/graphql';
const WEBSOCKET_ENDPOINT = process.env.REACT_APP_WS_ENDPOINT || 'ws://localhost:4000/graphql';
/**
 * Auth Link - Injects JWT token into Authorization header
 */
const authLink = new ApolloLink((operation, forward) => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('auth_token') : null;
    operation.setContext({
        headers: {
            Authorization: token ? `Bearer ${token}` : '',
        },
    });
    return forward(operation);
});
/**
 * WebSocket link for subscriptions with authentication
 */
const wsLink = new GraphQLWsLink(createClient({
    url: WEBSOCKET_ENDPOINT,
    lazy: true,
    retryAttempts: 3,
    connectionParams: () => {
        const token = typeof window !== 'undefined' ? localStorage.getItem('auth_token') : null;
        return token ? { Authorization: `Bearer ${token}` } : {};
    },
}));
// HTTP link for queries/mutations
const httpLink = new HttpLink({
    uri: GRAPHQL_ENDPOINT, // Use the HTTP endpoint
});
// Split links based on operation type
const splitLink = split(({ query }) => {
    const definition = getMainDefinition(query);
    return (definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription');
}, wsLink, // Use wsLink for subscriptions
httpLink // Use httpLink for queries/mutations
);
// Combine authLink with splitLink
const client = new ApolloClient({
    link: authLink.concat(splitLink),
    cache: new InMemoryCache(),
});
export default client;
